const ATTR_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];
const STORE_KEY = "lead_attribution";

export const pushEvent = (event, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

export const captureAttribution = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  ATTR_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) found[k] = v.slice(0, 200);
  });
  try {
    if (Object.keys(found).length) {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({ ...found, landing_page: window.location.pathname }));
    } else if (!sessionStorage.getItem(STORE_KEY) && document.referrer && !document.referrer.includes(window.location.host)) {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({ referrer: new URL(document.referrer).hostname }));
    }
  } catch {}
};

export const getAttribution = () => {
  try {
    const data = JSON.parse(sessionStorage.getItem(STORE_KEY) || "{}");
    return Object.keys(data).length ? { origem: Object.entries(data).map(([k, v]) => `${k}=${v}`).join(" | ") } : { origem: "direto" };
  } catch {
    return { origem: "direto" };
  }
};

export const initWhatsAppTracking = () => {
  document.addEventListener("click", (e) => {
    const link = e.target.closest && e.target.closest('a[href*="wa.me"]');
    if (!link) return;
    pushEvent("whatsapp_click", { click_location: link.dataset.waLocation || "outro" });
  });
};
